import { fetchJSON as fetchAPI } from './client';

export type SprintDashboard = {
  sprint_id: string; objectives: number; review_modules: number; review_dimensions: number;
  screens_to_review: number; quality_gates: number; generated_at: string;
};

export type SprintValidation = {
  valid: boolean; every_screen_audited: boolean; cognitive_load_validated: boolean;
  workflow_friction_documented: boolean; accessibility_review_passed: boolean;
  performance_review_passed: boolean; redesign_plan_complete: boolean; gaps?: string[];
};

export type Xdb002Status = {
  sprint_id: string; objectives: number; review_modules: number; screens_to_review: number;
  screen_review: boolean; workflow_review: boolean; redesign_plan: boolean; status: string;
};

const GOVERNANCE_BASE = import.meta.env.VITE_GOVERNANCE_API ?? '/api/v1/governance';
const fetchG = <T,>(path: string, init?: RequestInit) => fetchAPI<T>(`${GOVERNANCE_BASE}${path}`, init);

export const screenReviewXdb002Api = {
  dashboard: () => fetchG<SprintDashboard>('/xdb002/dashboard'),
  objectives: () => fetchG<{ objectives: { key: string; name: string; category: string }[] }>('/xdb002/objectives').then((r) => r.objectives),
  reviewModules: () => fetchG<{ modules: { key: string; name: string; category: string }[] }>('/xdb002/review-modules').then((r) => r.modules),
  reviewDimensions: () => fetchG<{ dimensions: { key: string; name: string; category: string }[] }>('/xdb002/review-dimensions').then((r) => r.dimensions),
  screens: () => fetchG<{ screens: { key: string; name: string; category: string; purpose: string }[] }>('/xdb002/screens').then((r) => r.screens),
  providers: () => fetchG<{ providers: { key: string; name: string; interface: string }[] }>('/xdb002/service-architecture').then((r) => r.providers),
  backgroundJobs: () => fetchG<{ jobs: { key: string; name: string; schedule?: string }[] }>('/xdb002/background-jobs').then((r) => r.jobs),
  qualityGates: () => fetchG<{ gates: { key: string; name: string; blocking: boolean }[] }>('/xdb002/quality-gates').then((r) => r.gates),
  validate: (attrs: Record<string, boolean>) =>
    fetchG<SprintValidation>('/xdb002/validate', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attrs }) }),
  status: () => fetchG<Xdb002Status>('/xdb002/status'),
};
